import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconButton } from '@/ui';
import { useCommunities } from '@/hooks';
import { CommunityJoinButton } from './DiscoveryCommunityCard';
import landscape from '@/features/landing/assets/hero-landscape-v1.png';

const Hero = styled.section`
  position: relative;
  overflow: hidden;
  min-height: 210px;
  padding: 28px 54px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background:
    linear-gradient(
      90deg,
      rgba(16, 12, 36, 0.96),
      rgba(21, 15, 47, 0.7) 52%,
      rgba(21, 15, 47, 0.18)
    ),
    url(${landscape}) center / cover;
  color: #fff;
  h2,
  p {
    margin: 0;
    max-width: 390px;
  }
  h2 {
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
  p {
    line-height: 1.5;
    font-size: ${({ theme }) => theme.fontSize.sm};
    color: #e2ddec;
  }
  a {
    color: #fff;
  }
  button {
    color: #fff;
    border-color: #9c88b4;
    background: rgba(18, 14, 38, 0.8);
  }
  @media (max-width: 560px) {
    padding: 24px 42px;
  }
`;
const Previous = styled.div`
  position: absolute;
  left: 4px;
  top: calc(50% - 20px);
`;
const Next = styled.div`
  position: absolute;
  right: 4px;
  top: calc(50% - 20px);
`;
const Position = styled.span`
  position: absolute;
  right: 16px;
  bottom: 12px;
  font-size: 12px;
  color: #e2ddec;
`;

export function FeaturedCommunity() {
  const { communities } = useCommunities();
  const [index, setIndex] = useState(0);
  const featured = communities.slice(0, 5);
  const current = featured[index % featured.length];
  if (!current) return null;
  return (
    <Hero aria-label="Featured community">
      <small>Featured Community</small>
      <h2>
        <Link to={`/communities/${current.id}`}>{current.name}</Link>
      </h2>
      <p>{current.tagline || current.description}</p>
      <CommunityJoinButton key={current.id} community={current} />
      <small>{current.members}</small>
      {featured.length > 1 && (
        <>
          <Previous>
            <IconButton
              icon="chevron-left"
              label="Previous community"
              onClick={() => setIndex((i) => (i - 1 + featured.length) % featured.length)}
            />
          </Previous>
          <Next>
            <IconButton
              icon="chevron-right"
              label="Next community"
              onClick={() => setIndex((i) => (i + 1) % featured.length)}
            />
          </Next>
          <Position aria-live="polite">
            {(index % featured.length) + 1} / {featured.length}
          </Position>
        </>
      )}
    </Hero>
  );
}
